import { CardEntity, CardFilter } from '../../models'

export const SET_CARDS = 'SET_CARDS'
export const SET_TOTAL_CARDS = 'SET_TOTAL_CARDS'
export const SET_CARDS_LOADED = 'SET_CARDS_LOADED'
export const SET_CARD_FILTER = 'SET_CARD_FILTER'
export const SET_SELECTED_CARD_ID = 'SET_SELECTED_CARD_ID'
export const SET_SHOW_PAY_IN_MODAL = 'SET_SHOW_PAY_IN_MODAL'

export interface CardState {
  cards: CardEntity[]
  totalCards: number
  isCardsLoaded: boolean
  cardFilter: CardFilter
  selectedCardId?: string
  showPayInModal: boolean
}

interface SetCardsAction {
  type: typeof SET_CARDS
  payload: CardEntity[]
}

interface SetTotalCardsAction {
  type: typeof SET_TOTAL_CARDS
  payload: number
}

interface SetCardsLoadedAction {
  type: typeof SET_CARDS_LOADED
  payload: boolean
}

interface SetCardFilterAction {
  type: typeof SET_CARD_FILTER
  payload: CardFilter
}

interface SetSelectedCardIdAction {
  type: typeof SET_SELECTED_CARD_ID
  payload?: string
}

interface SetShowPayInModalAction {
  type: typeof SET_SHOW_PAY_IN_MODAL
  payload: boolean
}

export type CardAction =
  | SetCardsAction
  | SetCardsLoadedAction
  | SetCardFilterAction
  | SetTotalCardsAction
  | SetSelectedCardIdAction
  | SetShowPayInModalAction
